import PropTypes from 'prop-types';
import React from 'react';
import styles from './styles.module.scss';
import { Image, Row, Col} from 'react-bootstrap';
import SixSenseIcon from 'src/legacy/images/six_sense.png';
import SixSenseActivationPage from './SixSenseActivationPage';
import DeactivateIntegrationContainer from "src/legacy/components/DeactivateIntegration/index";
import BackButton from 'src/legacy/components/BackButton';
import { localizedStrings } from 'src/localization/index.jsx';
import { shouldFetchIntegrations } from 'src/legacy/services/utils';

class SixSenseView extends React.Component {
  static contextTypes = {
    store: PropTypes.object.isRequired
  }

  constructor(props){
    super(props);
    this.state={
      deleteConfirmation: false
    }
    this._handleDeactivateClicked = this._handleDeactivateClicked.bind(this);

    this.localizedIntegrations = localizedStrings.components.integrations;
    this.localizedCommons = localizedStrings.commons;
    this.localizedSixSense = localizedStrings.components.integrations.six_sense;
  }

  _handleDeactivateClicked(){
    this.setState({
      deleteConfirmation: true
    })
  }

  componentDidMount(){

    if(shouldFetchIntegrations(this.props.integrations)) {
      this.props.fetchIntegrations();
    }

  }
  
  render(){
    return (
      <div className={styles.content} fluid>
        <Row className={styles.row}>
          <Col md={3} className={styles.left}>
            <BackButton className={styles.back} title={this.localizedCommons.actions.back} onClick={() => {
              this.props.handleIntegrationsBackButton();
            }} />
            <div className={ styles.heading }>
              <Image src={SixSenseIcon} />
              <h2 className={styles.name}>{ this.localizedSixSense.title }</h2>
              <p className={styles.description}>{ this.localizedSixSense.sub_text }</p>
              { this.props.integration &&
                <button className={styles.button}  onClick={this._handleDeactivateClicked}>
                  { this.localizedIntegrations.actions.deactivate }
                </button>
              }
            </div>  
          </Col>
          <Col md={9} className={styles.right}>
            <SixSenseActivationPage store={this.context.store} integration = { this.props.integration }/>  
          </Col>
        
        </Row>
        <DeactivateIntegrationContainer 
          name = {this.localizedSixSense.title}
          type="six-sense"
          message={this.localizedSixSense.deactivate_slider.sub_text}
          show={this.state.deleteConfirmation}
          onCancel={()=> {
          this.setState({
             deleteConfirmation: false
          })
        }}
       />
      </div>
    );
  }
}

export default SixSenseView;